import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setDriverManagementReloadModalOpen,
  setShowReloadDriverManagement,
} from "../../../reducers/ownApp";
import {
  fetchDepotMatrixWeek,
  resetDriverManagement,
} from "../../../reducers/driverManagement/thunkActions";
import {
  getSelectedDepot,
  driverManagementReloadModalOpenSelector,
} from "../../../reducers/ownApp/selectors";

import { Modal } from "../Modal";
import { DriverManagementReloadContent } from "./DriverManagementReloadContent";
import { DriverManagementReloadActions } from "./DriverManagementReloadActions";

export const DriverManagementReloadModal = memo(() => {
  const dispatch = useDispatch();
  const open = useSelector(driverManagementReloadModalOpenSelector);
  const selectedDepot = useSelector(getSelectedDepot);

  const onClose = () => {
    dispatch(setDriverManagementReloadModalOpen(false));
  };
  const onContinue = async () => {
    onClose();
    dispatch(setShowReloadDriverManagement(false));
    await dispatch(resetDriverManagement());
    await dispatch(fetchDepotMatrixWeek({ depotCode: selectedDepot }));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={"Reload Depot"}
      content={<DriverManagementReloadContent />}
      actions={
        <DriverManagementReloadActions
          onCancel={onClose}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
    />
  );
});
